import React, { useCallback, useEffect, useState } from "react";
import ComentariosCard from "./ComentariosCard";
import { useDispatch, useSelector } from "react-redux";
import {
  getComentarios,
  getFluxoTrabalho,
} from "../../selectors/workflow.selectors";
import useCompleteForm from "../../hooks/useCompleteForm";
import validators from "../../utils/validators";
import { actions } from "../../actions/workflow.actions";
import { getUsuarioLogado } from "../../selectors/usuario.selectors";

const ComentariosCardConnected = () => {
  const dispatch = useDispatch();
  const { loading, data, submitting } = useSelector(getComentarios);
  const fluxoTrabalho = useSelector(getFluxoTrabalho);
  const usuario = useSelector(getUsuarioLogado);
  const [search, setSearch] = useState('');

  const [comentariosFiltrados, setComentariosFiltrados] = useState([]);

  useEffect(() => {
    setComentariosFiltrados(data);
  }, [data]);

  const [formProps, handleSubmit] = useCompleteForm({
    rules: useCallback(
      () => ({
        comentario: validators.string({ required: true }),
      }),
      []
    ),
    initialValues: useCallback(
      () => ({
        comentario: "",
        confidencial: false,
      }),
      []
    ),
    handleSubmitWithForm: useCallback(
      (form) => {
        return (values) => {
          dispatch(
            actions.gravarComentario.request({
              ...values,
              callback: form.setValue("comentario", ""),
            })
          );
        };
      },
      [dispatch]
    ),
  });

  const handleEditarComentario = useCallback(
    (comentario) => {
      dispatch(actions.exibirEditarComentario(true, comentario));
    },
    [dispatch]
  );

  const handleExcluirComentario = useCallback(
    (comentario) => {
      dispatch(actions.excluirComentario.request(comentario.id));
    },
    [dispatch]
  );

  const handleDestacar = useCallback(
    (comentario) => {
      dispatch(actions.destacarComentario.request(comentario));
    },
    [dispatch]
  );

  const handlePesquisa = useCallback((value) => {
    setSearch(value);
    setComentariosFiltrados(
      data.filter(
        (c) =>
          c.texto.toLowerCase().includes(value.toLowerCase()) ||
        c.nomeUsuario.toLowerCase().includes(value.toLowerCase())
      )
    );
  }, [data]);

  return (
    <ComentariosCard
      loading={loading}
      comentarios={data}
      formProps={formProps}
      handleSubmit={handleSubmit}
      submitting={submitting}
      handleEditarComentario={handleEditarComentario}
      handleExcluirComentario={handleExcluirComentario}
      handleDestacar={handleDestacar}
      fluxoTrabalho={fluxoTrabalho}
      usuario={usuario}
      handlePesquisa={handlePesquisa}
      comentariosFiltrados={comentariosFiltrados}
      search={search}
    />
  );
};

export default ComentariosCardConnected;
